import { format } from 'date-fns'
// import { format } from 'date-fns/format'
// TODO check/try: root imports
import { mapperModuleMedia } from '../../../core/data-layer/modules/mappers'
import mapperImage from '../../../core/data-layer/utils/mappers/mapper-image'
import type { MapperOptions, ModuleMedia } from '#layers/core/types'
const { getI18nFormatterLocale, getDateFormatLocale } = useLocales()

/**
 * Page legal mapper
 * normalizes data to be used in pages
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  const dateFnsLocale = getI18nFormatterLocale(options.locale)
  const dateFormat = getDateFormatLocale(options.locale)
  const imageData = mapperModuleMedia(data?.image, {}) as ModuleMedia
  return {
    title: data.title || '',
    disclaimer: data.disclaimer || null, // rich text
    introText: data.introText || null, // rich text
    image: imageData
      ? mapperImage(
          imageData.original,
          {
            small: { width: 327, height: 184, aspectRatio: '16 / 9' },
            medium: { width: 672, height: 378, aspectRatio: '16 / 9' },
            large: { width: 784, height: 441, aspectRatio: '16 / 9' }
          },
          '',
          data.fpZoom
        )
      : null,
    imageLink: imageData ? imageData?.link : null,
    downloadableImage: data.downloadableImage || false,
    text: data.text || null, // rich text
    locationAndTime:
      data?.date && data?.city?.name
        ? `${data.city?.name} · ${format(new Date(data.date), dateFormat, { locale: dateFnsLocale })}`
        : '',
    downloadImageLink: imageData?.link
      ? {
          ...imageData.link,
          content: options.labels?.downloadImage || '',
          iconRight: { name: 'chevron-right-small', category: 'arrows' }
        }
      : null,
    pageContentComponentName: 'PageContentPressAndMediaDetail'
  }
}
